import React from "react";
import {Navigate,Route,Routes,useLocation} from "react-router-dom";
import ProjectManagerGoodsInList from "./list";
import { Details } from "./details";

const ProjectManagerGoodsin = () => {
  const Location = useLocation();

  return (
    <>
      {/* <div className="main-page-container"> */}
      <Routes>
        <Route path={`/`} element={<Navigate replace="/" to={`${Location.pathname}/list`} />} />
        <Route path={"list"} element={<ProjectManagerGoodsInList />} />
        <Route path={"detail/:id"} element={<Details />} />
      </Routes>
    </>
  );
};

export default ProjectManagerGoodsin;
